<template>
    <div
        v-if="terms.length"
        class="bo-search-history"
        :class="{ editing }"
    >
        <div class="search-history-header">
            <span class="search-history-title">{{ translations?.search_history ?? "Search History" }}</span>
            <div
                v-if="!editing"
                class="search-history-actions"
            >
                <button
                    type="button"
                    class="search-history-action"
                    @click="$emit('edit', true)"
                >
                    <i class="icon-deleteforever"></i>
                    {{ translations?.clear ?? "Clear" }}
                </button>
            </div>
            <div
                v-else
                class="search-history-actions"
            >
                <button
                    type="button"
                    class="search-history-action clear-all"
                    @click="$emit('clear-all')"
                >
                    <i class="icon-deleteforever"></i>
                    {{ translations?.clear_all ?? "Clear All" }}
                </button>
                <span class="search-history-separator"></span>
                <button
                    type="button"
                    class="search-history-action"
                    @click="$emit('edit', false)"
                >
                    {{ translations?.done ?? "Done" }}
                </button>
            </div>
        </div>
        <!-- rows past maxRows are cut whole by max-height -->
        <div
            class="search-history-terms"
            :style="{ '--search-history-rows': maxRows }"
        >
            <span
                v-for="term in terms"
                :key="term"
                class="search-history-term"
                @click="!editing && $emit('select', term)"
            >
                <span class="term-text">{{ term }}</span>
                <i
                    v-if="editing"
                    class="icon-close"
                    @click.stop="$emit('remove', term)"
                ></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        terms: {
            type: Array,
            default: () => [],
        },
        editing: {
            type: Boolean,
            default: false,
        },
        // 2 rows on desktop, 4 on mobile
        maxRows: {
            type: Number,
            default: 2,
        },
        translations: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
